import { render, staticRenderFns } from "./form9.vue?vue&type=template&id=bd0eae0e&scoped=true&"
import script from "./form9.vue?vue&type=script&lang=js&"
export * from "./form9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0eae0e",
  null
  
)

export default component.exports